<template>
    <div>
        <el-dialog v-if="dialogVoteVisible" v-el-drag-dialog :close-on-click-modal="false" :title="'会议决议投票'" :visible.sync="dialogVoteVisible" width="1000px">
            <div v-if="rowData.id" class="vote_main">
                 <div class="vote_content">
                    <div style="line-height: 18px;margin-bottom: 20px;font-size: 16px;">{{ rowData.voteName }}</div>
                     <el-radio-group v-model="radio" class="vote_radio" :disabled="!disable">
                        <el-radio v-for="item in voteData.passenger.subjects[0].passenger.choices" :key="item.id" :label="item">{{ item.subject }}</el-radio>
                    </el-radio-group>
                 </div>
                 <div v-if="voteData.passenger.attachments.length" class="vote_attach">
                    <div v-for="item in voteData.passenger.attachments" :key="item.id" class="attach" @click="attachClick(item)">
                        <div class="attach_img">
                            <img :src="imgUrl(item)" style="width: 24px;" alt="" />
                        </div>
                        <div class="attach_info">
                            <div class="attach_name">{{ item.fileName }}</div>
                            <div>
                                <span>{{ item.uploadTime }}</span>
                                <span style="margin-left: 20px;">{{ item.fileSize }}</span>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVoteVisible = false">关 闭</el-button>
                <el-button v-if="disable" @click="SignforConfirm(1)">暂 存</el-button>
                <el-button v-if="disable" type="primary" @click="SignforConfirm(2)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
const moment = require('moment')
const { uuid } = require('@/global/utils/index.js')
export default {
    components: {
    },
    filters: {
        formatTime: function (val) {
            if (val) {
                return moment().format('YYYY-MM-DD HH:mm')
            }
            return val
        }
    },
    props: {},
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            loginUser: this.$store.getters.loginUser,
            dialogVoteVisible: false,
            doing: false,
            rowData: {},
            voteData: {},
            radio: {},
            disable: true
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {

    },
    created() {
        this.$bus.on('openVoteDialog', this.openVoteDialog)
    },
    beforeDestroy() {
        this.$bus.off('openVoteDialog', this.openVoteDialog)
    },
    mounted() {},
    methods: {
        async openVoteDialog(row, type = true) {
            this.dialogVoteVisible = true
            this.disable = type
            await this.getVoteData(row)

            this.$http({
                method: 'get',
                url: '/hygl/voteResult/getById',
                params: {
                    id: row.id
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.rowData = res.body.vo
                    if (this.rowData.passenger.voteResultInfos.length) {
                        this.rowData.passenger.voteResultInfos.sort((item1, item2) => {
                            return new Date(item2.resultTime).getTime() - new Date(item1.resultTime).getTime()
                        })
                        let radioId = this.rowData.passenger.voteResultInfos[0].choiceId
                        let arr = this.voteData.passenger.subjects[0].passenger.choices.filter(item => item.id === radioId)
                        if (arr.length) {
                            this.radio = arr[0]
                        } else {
                            this.radio = {}
                        }
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        async getVoteData(row) {
            await this.$http({
                method: 'get',
                url: '/hygl/vote/getById',
                params: {
                    id: row.voteId
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.voteData = res.body.vo
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        SignforConfirm(type) {
            console.log(this.radio)
            if (!this.radio.id) {
                this.$alert('请选择。', '操作提示', { type: 'warning' })
                return
            }
            const voteResultInfosObj = {
                // id: uuid(),
                resultId: this.rowData.id,
                subjectId: this.voteData.passenger.subjects[0].id,
                subjectName: this.voteData.passenger.subjects[0].subject,
                voteType: this.voteData.passenger.subjects[0].voteType,
                choiceId: this.radio.id,
                choiceName: this.radio.subject,
                resultTime: moment(new Date()).format('YYYY-MM-DD HH:mm'),
                personAccount: this.loginUser.personAccount,
                status: 1
            }
            if (!this.rowData.passenger.voteResultInfos.length) {
                this.rowData.passenger.voteResultInfos.push(voteResultInfosObj)
            } else {
                this.rowData.passenger.voteResultInfos[0] = voteResultInfosObj
            }
            this.rowData.choiceStatus = type

            this.$http({
                method: 'PUT',
                url: '/hygl/voteResult/update',
                data: this.rowData
            }).then((res) => {
                if (res.code === 'success') {
                    this.$message.success('投票成功。')
                    this.dialogVoteVisible = false
                    this.$bus.emit('refreshListData')
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        attachClick(file) {
            window.open(`/apigw/hygl/vote/downloadById?inline=true&attachIds=${file.id}&topdf=false&httpPort=${location.port}`)
        },
        // 返回图片路径
        imgUrl(item) {
            // 文件类型
            var extension = item.oriangialName || item.fileName
            extension = extension.substring(extension.lastIndexOf('.'))
            if (extension === '.doc' || extension === '.docx') {
                return 'images/w-imgs/email/word.png'
            }
            if (extension === '.ppt' || extension === '.pptx') {
                return 'images/w-imgs/email/ppt.png'
            }
            if (extension === '.xls' || extension === '.xlsx') {
                return 'images/w-imgs/email/excel.png'
            }
            if (extension === '.pdf') {
                return 'images/w-imgs/email/pdf.png'
            }
            if (extension === '.ofd') {
                return 'images/w-imgs/email/ofd.png'
            }
            if (extension === '.txt') {
                return 'images/w-imgs/email/txt.png'
            } else if (extension === '.audio' || extension === '.amr' || extension === '.mp3' || extension === '.wav') {
                return 'images/w-imgs/email/audio.png'
            } else if (extension === '.video' || extension === '.mp4' || extension === '.mov') {
                return 'images/w-imgs/email/video.png'
            } else if (extension === '.zip' || extension === '.rar') {
                return 'images/w-imgs/email/zip.png'
            } else if (extension === '.image' || extension === '.mp4' || extension === '.jpg' || extension === '.jpeg' || extension === '.png' || extension === '.gif' || extension === '.bmp' || extension === '.svg') {
                return 'images/w-imgs/email/picture.png'
            } else if (extension === ' ') {
                return 'images/w-imgs/email/none.png'
            } else {
                return 'images/w-imgs/email/其他.png'
            }
        }
    }
}
</script>

<style scoped lang="scss">
.vote_main {
    width: 100%;
    height: 100%;
    border: 1px solid #dee2e6;
    .vote_content {
        padding: 15px 10px;
        border-bottom: 1px solid #dee2e6;
        .vote_radio {
            display: flex;
            flex-direction: column;
            .el-radio {
                margin-bottom: 15px;
            }
        }
    }
    .vote_attach {
        width: 100%;
        height: 100%;
        padding: 10px;
        .attach {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            padding: 5px 0;
            cursor: pointer;
            &:last-child {
                margin-bottom: 0;
            }
            &:hover {
                background: #faf8f8;
            }
            .attach_img {
                margin-right: 10px;
            }
            .attach_info {
                font-size: 14px;
                color: #b2b2b2;
            }
            .attach_name {
                font-size: 15px;
                color: #666;
                margin-bottom: 4px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
            }
        }
    }
}
</style>
